// extracted by mini-css-extract-plugin
export var actions = "_4i-0";
export var actionsContainer = "_4i-7";
export var border = "_4i-1";
export var childFullHeight = "_4i-f";
export var collapse = "_4i-2";
export var content = "_4i-a";
export var contentChild = "_4i-e";
export var fullscreen = "_4i-c";
export var hasLeftRadius = "_4i-k";
export var headerContainer = "_4i-3";
export var headerRow = "_4i-5";
export var hidePadding = "_4i-b";
export var navCollapsedGap = "_4i-l";
export var noScrollX = "_4i-m";
export var noScrollY = "_4i-n";
export var noTopPadding = "_4i-i";
export var optOutTopPadding = "_4i-d";
export var pageMain = "_4i-j";
export var pageOuter = "_4i-g";
export var pagePadding = "_4i-8";
export var pageScroll = "_4i-9";
export var profile = "_4i-o";
export var profileContainer = "_4i-p";
export var profileImage = "_4i-q";
export var profileMain = "_4i-r";
export var profileSubtitle = "_4i-t";
export var profileTitle = "_4i-s";
export var showLeftPadding = "_4i-h";
export var tabsPortalSlot = "_4i-6";
export var tabsWrapper = "_4i-4";
export var title = "_4i-u";